import { render, staticRenderFns } from "./RecoveryForm.vue?vue&type=template&id=7748afdb&scoped=true"
import script from "./RecoveryForm.vue?vue&type=script&lang=js"
export * from "./RecoveryForm.vue?vue&type=script&lang=js"
import style0 from "./RecoveryForm.vue?vue&type=style&index=0&id=7748afdb&prod&lang=sass"
import style1 from "./RecoveryForm.vue?vue&type=style&index=1&id=7748afdb&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7748afdb",
  null
  
)

export default component.exports